import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';

export interface ArrowNewIconProps extends NewIconProps {
  className?: string;
  color?: string;
  direction?: 'left' | 'right' | 'up' | 'down';
}

export const ArrowIcon = ({
  className,
  color = Color.Gray700,
  direction = 'left',
  opacity = 1.0,
}: ArrowNewIconProps) => {
  let rotate = 0;

  if (direction === 'up') {
    rotate = 90;
  } else if (direction === 'right') {
    rotate = 180;
  } else if (direction === 'down') {
    rotate = 270;
  }
  return (
    <Icon
      className={twMerge(`size-[24px]`, className)}
      color={color}
      opacity={opacity}
      style={{
        transform: `rotate(${rotate}deg)`,
      }}
    />
  );
};

const Icon = ({
  className,
  color,
  opacity = 1,
  style,
}: {
  className?: string;
  style?: CSSProperties;
} & NewIconProps) => (
  <svg
    className={className}
    style={style}
    width="100%"
    height="100%"
    opacity={opacity}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M15.21 4L7 12.21L15.21 20.41L16.62 19L9.83 12.21L16.62 5.41L15.21 4Z" fill={color} />
  </svg>
);
